import { Link } from "react-router-dom";
import Book from "react-feather/dist/icons/book";

import style from "./style.module.scss";
import cover from "../../../assets/cover.png";
import dimentions from "../../../assets/dimentions.png";
import formats from "../../../assets/formats.png";
import pages from "../../../assets/pages.png";
import paper from "../../../assets/paper.png";
import reliure from "../../../assets/reliure.png";
import Page from "../page";
import { Button } from "../../../ui";

function About() {
  return (
    <Page isFullscreen>
      <div className={style.section}>
        <h1>Écrivez votre histoire en photos</h1>
        <p>
          Vous avez beaucoup de photos stockées sur votre ordinateurs, sur vos cartes mémoires,
          votre disque dur ou sur votre smartphone et vous ne les regardez jamais ?
        </p>
        <ul>
          <li>
            Immortalisez ces photos de vacances entre cousins et cousines, d'une sortie en famille,
            ou l'arrivée d'un petit boutchou.
          </li>
          <li>Partagez tous ces souvenirs dans un véritable album photo imprimé et relié.</li>
          <li>
            C'est simple, cet album c'est vous qui le créez, en racontant votre histoire en photo
            que vous aurez un plaisir de revoir dans quelques années.
          </li>
        </ul>
        <p>
          <strong>
            Commencez votre collection d'albums photos et enrichissez votre bibliothèque.
          </strong>
        </p>
      </div>
      <div className={style.fullscreenSection}>
        <div className={style.blocks}>
          <div className={style.block}>
            <div className={style.blockContent}>
              <img src={dimentions} alt="Dimensions" />
              <h3>Dimensions</h3>
              <p>Dimensions exactes : carré (20×20 cm).</p>
            </div>
          </div>
          <div className={style.block}>
            <div className={style.blockContent}>
              <img src={pages} alt="Pages" />
              <h3>Nombre de photos</h3>
              <p>1 à 4 photos par page.</p>
            </div>
          </div>
          <div className={style.block}>
            <div className={style.blockContent}>
              <img src={formats} alt="Formats" />
              <h3>Mise en page</h3>
              <p>10 types de mises en page possibles, avec ou sans texte.</p>
            </div>
          </div>
          <div className={style.block}>
            <div className={style.blockContent}>
              <img src={paper} alt="Paper" />
              <h3>Qualité du papier</h3>
              <p>Papier haute qualité (170g page interne, 250g page de couverture).</p>
            </div>
          </div>
          <div className={style.block}>
            <div className={style.blockContent}>
              <img src={cover} alt="Cover" />
              <h3>Couverture</h3>
              <p>Couverture souple à personnaliser (couleur, thème, photo)</p>
            </div>
          </div>
          <div className={style.block}>
            <div className={style.blockContent}>
              <img src={reliure} alt="Reliure" />
              <h3>Reliure</h3>
              <p>Reliure à ressort métalique de qualité.</p>
            </div>
          </div>
        </div>
      </div>
      <div className={style.section}>
        <Link to="/start/photo-book" className={style.link}>
          <Button className={style.button} isPrimary isLarge>
            <Book />
            Créer votre livre photo
          </Button>
        </Link>
      </div>
      <div className={style.section}>
        <h2>Comment faire pour commander un album</h2>
        <p>
          Pour vous simplifier la vie, nous avons créé une petite vidéo montrant les différentes
          étapes de création et commande d'un album photo.
        </p>
        <div className={style.videoWrapper}>
          <iframe
            src="https://www.youtube-nocookie.com/embed/edwhS97N6vg?rel=0&amp;showinfo=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Tutorial video"
          />
        </div>
      </div>
    </Page>
  );
}

export default About;
